import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function VendorInvoiceAttachedVendorInvoiceCtrl ($scope, $state, $translate, workshopAPI) {

  $scope.showAttachedVendorInvoices = false;

  $scope.tableSettings = {
    columns: [
      {
        classes: 'all-caps',
        field  : 'vendor_invoice_number',
        header : {
          text: $translate.instant('INVOICE_SPACE.INVOICE_NUMBER')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'invoice_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'company_name',
        header: {
          text: $translate.instant('VENDOR_SPACE.SUPPLIER')
        },
      },
      {
        field : 'item_code',
        header: {
          text: $translate.instant('PRODUCT_SPACE.ITEM_CODE')
        },
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewInvoice(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getInvoices = function () {
    return workshopAPI.get('/vendor_invoice_items/attached_vendor_invoices', $scope.invoice.id)
    .then(invoices => {
      $scope.invoices = invoices;

      return invoices;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewInvoice(event.row);
  };

  $scope.viewInvoice = function (invoice) {
    $state.go('app.vendor-invoice', {
      id       : invoice.vendor_invoice_id,
      vendor_id: invoice.vendor_id
    });
  };

  $scope.getInvoices();
}